import { array, bool, func, string, object } from 'prop-types'
import { kuiperClassNames, ListManager } from '@opallabs/kuiper'
import { isApproval } from '../../../helpers/matchers'
import { itemSorter, modifiedPeople } from './helpers'
import Item from './Item'
import ItemListHeading from './ItemListHeading'

import './styles.scss'

const shouldRenderMenu = (phase) =>
  !phase.is_active && !phase.is_complete && isApproval(phase.phase_type)

const ItemContainer = ({
  currentUser,
  entitySaveMethod,
  isDirtyCheck,
  onPhaseItemsChanged,
  phaseItems,
  people,
  renderTitle,
  theme,
  title,
  ...otherProps
}) => {
  const {
    createPhaseItem,
    dueDate,
    is_active: isActive,
    is_complete: isComplete,
    is_current: isCurrent,
    locked,
    onDestroyPhaseItem,
    phase_type: phaseType,
    placeholderPlacement,
    updatePhaseItem,
    workflowLocation,
  } = otherProps
  const phaseId = parseInt(otherProps.id, 10)
  const modifiedUsers = modifiedPeople(people)

  return (
    <div className={kuiperClassNames('phase-item-group')}>
      <ItemListHeading
        {...otherProps}
        onChangePhaseOptions={otherProps.onChangePhaseOptions}
        renderMenu={shouldRenderMenu(otherProps)}
        shouldRender={renderTitle}
        theme={theme}
        title={title}
      />

      <ul className={kuiperClassNames('phase-item-list')}>
        <ListManager
          animationName={kuiperClassNames('insert-item')}
          createNewTask={otherProps.createNewTask}
          createIntegrationTask={otherProps.createIntegrationTask}
          createItem={createPhaseItem.bind(this, otherProps)}
          currentUser={currentUser}
          dueDate={dueDate}
          editing={false}
          enabledIntegrations={otherProps.enabledIntegrations}
          entitySaveMethod={entitySaveMethod}
          isActive={isActive}
          isComplete={isComplete}
          isCurrent={isCurrent}
          isDirtyCheck={isDirtyCheck}
          itemRenderer={Item}
          items={phaseItems}
          itemSorter={itemSorter}
          loadIntegrationTask={otherProps.loadIntegrationTask}
          locked={locked}
          onItemsChanged={onPhaseItemsChanged}
          people={modifiedUsers}
          phaseId={phaseId}
          phaseType={phaseType}
          placeholder={placeholderPlacement}
          removeItem={onDestroyPhaseItem.bind(this, otherProps)}
          theme={theme}
          transitionTime={1}
          updateItem={updatePhaseItem.bind(this, otherProps)}
          workflowLocation={workflowLocation}
        />
      </ul>
    </div>
  )
}

ItemContainer.propTypes = {
  createIntegrationTask: func,
  currentUser: object,
  entitySaveMethod: func,
  isDirtyCheck: func,
  onPhaseItemsChanged: func,
  people: array,
  phaseItems: array.isRequired,
  renderTitle: bool,
  theme: string,
  title: string,
}

export default ItemContainer
